import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Users, GraduationCap, ClipboardList, Clock, Award, Download, ArrowRight } from "lucide-react";

export default function Dashboard() {
  const [counts, setCounts] = useState({ teachers: 0, students: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [t, s] = await Promise.all([
          api.get("/admin/teachers"),
          api.get("/admin/students"),
        ]);
        setCounts({
          teachers: t.data.filter((x) => x.active).length,
          students: s.data.filter((x) => x.active).length,
        });
      } catch (e) {
        /* ignore */
      }
    })();
  }, []);

  return (
    <div className="max-w-5xl" data-testid="admin-dashboard">
      <h1 className="font-heading text-2xl sm:text-3xl font-medium tracking-tight text-foreground">
        Dashboard
      </h1>
      <p className="mt-1 text-muted-foreground">Manage your school's teachers and students.</p>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        <Link
          to="/admin/teachers"
          data-testid="card-teachers"
          className="group bg-card border border-border rounded-lg p-6 transition-all duration-200 hover:-translate-y-[2px] hover:shadow-sm"
        >
          <div className="flex items-center justify-between">
            <div className="h-11 w-11 rounded-lg bg-primary/10 flex items-center justify-center">
              <Users className="h-6 w-6 text-primary" />
            </div>
            <ArrowRight className="h-5 w-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
          </div>
          <p className="mt-4 font-heading text-3xl font-medium text-foreground">{counts.teachers}</p>
          <p className="text-sm text-muted-foreground">Active teachers</p>
        </Link>

        <Link
          to="/admin/students"
          data-testid="card-students"
          className="group bg-card border border-border rounded-lg p-6 transition-all duration-200 hover:-translate-y-[2px] hover:shadow-sm"
        >
          <div className="flex items-center justify-between">
            <div className="h-11 w-11 rounded-lg bg-primary/10 flex items-center justify-center">
              <GraduationCap className="h-6 w-6 text-primary" />
            </div>
            <ArrowRight className="h-5 w-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
          </div>
          <p className="mt-4 font-heading text-3xl font-medium text-foreground">{counts.students}</p>
          <p className="text-sm text-muted-foreground">Active students</p>
        </Link>
      </div>

      <p className="mt-10 mb-3 text-[11px] uppercase tracking-wider text-muted-foreground/70 font-semibold">
        Quick links
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {[
          { label: "All Records", icon: ClipboardList, to: "/admin/records" },
          { label: "Time Entries", icon: Clock, to: "/admin/time-entries" },
          { label: "Points", icon: Award, to: "/admin/points" },
          { label: "Exports", icon: Download, to: "/admin/exports" },
        ].map(({ label, icon: Icon, to }) => (
          <Link
            key={label}
            to={to}
            data-testid={`quicklink-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className="group bg-card border border-border rounded-lg p-5 text-foreground transition-all duration-200 hover:-translate-y-[2px] hover:shadow-sm"
          >
            <Icon className="h-5 w-5 mb-2 text-primary" />
            <p className="text-sm font-medium">{label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
